/**
 * The header panel over a fridge no cabinet fits over (the user, 2026-11-01:
 * "is there any panel or filler that could go above a tall fridge?"). A tall
 * fridge can leave less room under the column's top than the shortest cabinet
 * the line makes there (Venus's 24"-deep bridges start at 12"); the gap was
 * left open. A flat ¾" panel closes it, between the column's side panels and
 * flush with their front, from just over the fridge (its gap kept) to the
 * column's top — on Venus cut from its ¾" panel sheet (`resolveSku`
 * `panelSku`, `fridgeHeader`), on any other line the system's flat panel.
 *
 * Pure.
 */
const { getWallAxes } = require('../kitchen-assembly/wallMath');
const { CABINET } = require('./cabinetFrontSpecs');
const { MIN_FILLER_IN } = require('./moduleSolver');

const IN = 0.0254;

/**
 * The header panel over the span `range` of `wall`, from `bottomY` to
 * `topY`, its front `depth` off the wall — or null where there is less room
 * than the fill's narrowest filler.
 */
function buildFridgeHeader(wall, range, { bottomY, topY, depth }) {
  const height = topY - bottomY;
  if (height < MIN_FILLER_IN * IN - 1e-9) return null;
  const axes = getWallAxes(wall);
  if (!axes) return null;
  const { start, wallDir, wallNormal, wallRotationY } = axes;
  const mid = (range.start + range.end) / 2;
  const thick = CABINET.panelThick;
  const off = depth - thick / 2;
  return {
    type: 'blank-panel',
    label: 'Fridge Header Panel',
    category: { 'blank-panel': true, fridgeHeader: true },
    center: {
      x: start.x + mid * wallDir.x + off * wallNormal.x,
      y: (bottomY + topY) / 2,
      z: start.z + mid * wallDir.z + off * wallNormal.z,
    },
    // drawn as exactly this ¾" slab: the panel drawing's default is a 24"
    // cabinet box pushed off the wall, which stood two feet into the room
    // from up here (the user, 2026-11-01)
    dimensions: {
      x: range.end - range.start,
      y: height,
      z: thick,
      plainSlab: true,
    },
    rotation: { x: 0, y: wallRotationY, z: 0 },
    parentWallIds: [wall.id],
    range: { start: range.start, end: range.end },
    // how far the column stands off the wall: the crown reads the opening
    // behind the panel as covered, as it does under an over-fridge cabinet
    // (`cabinet-trim/fronts.js`)
    columnDepth: depth,
  };
}

module.exports = { buildFridgeHeader };
